import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getInfoPerRegistrationPlate,editTicket, editTicketUser, getActiveReaders, getTicket, postRequest, blockTicket } from '../../api/axios';

import { TextField, Button, Box, Typography, Container, Alert, Grid, Dialog, DialogContent, FormControlLabel, Checkbox, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextFormatRounded } from '@mui/icons-material';
import { getUsername } from '../../context/AuthFunc';

const EditTicketByPlate = () => {
    const { t } = useTranslation('global');

    const { registration_plates } = useParams();
    const [openReadersModal, setOpenReadersModal] = useState(false);
    const [openActiveModal, setOpenActiveModal] = useState(false);
    const [ticket, setTicket] = useState(null);
    const [readers, setReaders] = useState([]);
    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');
    const [inactiveReason, setInactiveReason] = useState('');
    const navigate = useNavigate();

    const toUniqueNumberList = (input) => {
        const unique = (arr) => Array.from(new Set(arr));

        if (input == null) return [];

        let list = [];

        if (Array.isArray(input)) {
            list = input.map((x) => Number(x)).filter((n) => Number.isFinite(n));
            return unique(list);
        }

        if (typeof input === "string") {
            list = input
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
                .map((s) => Number(s))
                .filter((n) => Number.isFinite(n));
            return unique(list);
        }

        const one = Number(input);
        return Number.isFinite(one) ? [one] : [];
    };

    const fetchData = async () => {
        const params = new URLSearchParams({ registration: registration_plates })
        const response = await getInfoPerRegistrationPlate(params);
        if (!response || (Array.isArray(response) && response.length === 0) || (typeof response === 'object' && Object.keys(response).length === 0)) {
            setErrMsg(t("edit.ticketNotAvailable"));
            setTimeout(() => setErrMsg(''), 3000);
            return;
        }
        const ticketData = response;
        setTicket({
            ...ticketData,
            readers: toUniqueNumberList(ticketData?.readers),
        });
        console.log(response);
        console.log(ticket);
    };
    const fetchReaders = async () => {
        const response = await getActiveReaders();
        setReaders(response);
    };
    useEffect(() => {
        // Fetch ticket and user data
        fetchData();
        fetchReaders();
    }, [registration_plates]);

    const handleOpenActiveModal = () => setOpenActiveModal(true);
    const handleCloseActiveModal = (submit) => {
        setOpenActiveModal(false); // Close the modal first

        if (submit !== true) {
            setInactiveReason('');
            return;
        }
        if (!inactiveReason.trim()) {
            setErrMsg(t("edit.pleaseProvideReason"));
            setTimeout(() => setErrMsg(''), 3000);
            return;
        }        
        setTicket({...ticket, active : "0"});
    };
    
    const handleOpenReadersModal = () => setOpenReadersModal(true);
    const handleCloseReadersModal = () => setOpenReadersModal(false);

    const handleSave = async (e) => {
        const updatedTicket = {
            ...ticket,
            readers: toUniqueNumberList(ticket.readers),
        } 
        delete updatedTicket.name;
        delete updatedTicket.surname;
        delete updatedTicket.phone;
        e.preventDefault(); // Prevent default form submission
        console.log(updatedTicket);
        if(ticket.active == "0" && inactiveReason.trim()){
            const params = new URLSearchParams({
                id: ticket.ticket_id,
                user: getUsername(),
                desc: inactiveReason,
              });
            const block = blockTicket(params);
            console.log(block);
        }
        try {
           const updateT = await editTicket(updatedTicket);
           console.log(updateT.success);
        } catch (error) {
            setErrMsg(t("edit.errorDuringEdit"));
            setTimeout(() => setErrMsg(''), 3000);
        }
    };

    /*const handleCheckboxChange = (readerId, checked) => {
        const updatedReaders = checked
            ? [...ticket.readers, readerId] // Add readerId if checked
            : ticket.readers.filter(id => id !== readerId); // Remove readerId if unchecked
        setTicket({ ...ticket, readers: updatedReaders });
    };*/

    const handleReaderChange = (e) => {
        const { value, checked } = e.target;
        const id = Number(value);
        setTicket((prev) => {
            if (value === 'all') {
                return {
                    ...prev,
                    readers: checked
                        ? toUniqueNumberList(readers.map((reader) => reader.id))
                        : [],
                };
            }
            const updatedReaders = checked
                ? [...prev.readers, id]
                : prev.readers.filter((readerId) => readerId !== id);
            return {
                ...prev,
                readers: toUniqueNumberList(updatedReaders),
            };
        });
    };
    const handleActiveChange = () =>{
        if(ticket.active == "1"){
            setTicket({...ticket, active : "0"});
        }
        else{
            setTicket({...ticket, active : "1"})
        }
    }
    if (ticket === undefined || ticket == null) return <div>{t("edit.ticketNotAvailable")}</div>;


    return (

        <Container maxWidth="sm" style={{alignItems: "center", justifyContent:"center"}}>
            <Box sx={{ mt: 4, p: 3, borderRadius: 2, boxShadow: 3, backgroundColor: '#f9f9f9',}}>
                <Typography variant="h4" align="center" gutterBottom>
                    {t("edit.editTicket")}
                </Typography>
                
                <form onSubmit={handleSave} className="form">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="name"
                                label={t("edit.dateAndTimeOfTicketIssuance")}
                                value={ticket.create_time}
                                variant="outlined"
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                  }}
                            />
                        </Grid>
                    </Grid>
                    

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                        fullWidth
                                        id="registration"
                                        label={t("edit.registration")}
                                        value={ticket.registration}
                                        onChange={(e) => setTicket({...ticket, registration:e.target.value})}
                                        variant="outlined"
                                    />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                        fullWidth
                                        id="day_no"
                                        label={t("edit.numberOfDaysTheTicketIsValid")}
                                        value={ticket.day_no}
                                        onChange={(e) => setTicket({...ticket, day_no:e.target.value})}
                                        variant="outlined"
                                    />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="entry_no"
                                label={t("edit.numberOfPasses")}
                                value={ticket.entry_no}
                                onChange={(e) => setTicket({...ticket, entry_no:e.target.value})}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="daily_no"
                                label={t("edit.numberOfDailyPasses")}
                                value={ticket.daily_no}
                                onChange={(e) => setTicket({...ticket, daily_no:e.target.value})}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="hFrom"
                                label={t("edit.entryFrom")}
                                value={ticket.h_from}
                                onChange={(e) => setTicket({...ticket, h_from:e.target.value})}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="hTo"
                                label={t("edit.entryUntil")}
                                value={ticket.h_to}
                                onChange={(e) => setTicket({...ticket, h_to:e.target.value})}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={4}>
                            <Button 
                                variant="outlined" 
                                onClick={handleOpenReadersModal}
                                fullWidth
                            >
                                {t("edit.selectReaders")}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button 
                                variant="outlined" 
                                onClick={handleOpenActiveModal}
                                fullWidth
                            >
                                {t("edit.deactivateTicket")}
                            </Button>
                        </Grid>
                    </Grid>
                    {errMsg && (
                                <Box item xs={12}>
                                  <Alert severity="error" onClose={() => setErrMsg('')}>
                                    {errMsg}
                                  </Alert>
                                </Box>
                              )}
                              {succ && (
                                <Box item xs={12}>
                                  <Alert severity="success" onClose={() => setSucc('')}>
                                    {succ}
                                  </Alert>
                                </Box>
                    )}
                    <Dialog open={openActiveModal} onClose={() => handleCloseActiveModal(false)} fullWidth maxWidth="sm">
                        <DialogTitle>{t("edit.deactivateTicket")}</DialogTitle>
                        <DialogContent>
                            
                            <Typography>{t("edit.desc")}</Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                placeholder={t("edit.enterReason")}
                                value={inactiveReason}
                                onChange={(e) => setInactiveReason(e.target.value)}
                                sx={{
                                    padding: 0, // Ensures no extra padding
                                    "& .MuiOutlinedInput-root": {
                                        padding: "5px", // Adjust padding inside the input
                                    }}}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleCloseActiveModal(true)} color="primary" variant="contained">
                                {t("edit.save")}
                            </Button>
                            <Button onClick={() => handleCloseActiveModal(false)} color="primary" variant="contained">
                                {t("edit.cancel")}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={openReadersModal} onClose={handleCloseReadersModal} fullWidth maxWidth="sm">
                        <DialogTitle>{t("edit.readers")}</DialogTitle>
                        <DialogContent>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        value='all'
                                        onChange={handleReaderChange}
                                        checked={ticket.readers.length === readers.length}
                                    />
                                }
                                label={t("editItem.all")}
                            />
                            <Grid container spacing={1}>
                                {readers.map((reader) => (
                                    <Grid item xs={12} sm={6} key={reader.id}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    value={reader.id}
                                                    checked={ticket.readers.includes(Number(reader.id))}
                                                    onChange={handleReaderChange}
                                                />
                                            }
                                            label={reader.name}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseReadersModal} color="primary" variant="contained">
                                {t("edit.save")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            color="primary"
                            >
                            {t("edit.save")}
                            </Button>
                        </Grid>
            
                        <Grid item xs={12} sm={6}>
                            <Button
                            fullWidth
                            type="button"
                            variant="contained"
                            color="error"
                            onClick={() => { navigate('/') }}
                            >
                            {t("edit.cancel")}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Container>
        /*<div className='edit-form-container'>
            <div className='container-reader'>
                <h1>{t("edit.editTicket")}</h1>
                
                <label className='edit-label-fix'>
                {t("edit.ticket")}
                    <input
                        type="text"
                        value={ticket.ticket_id}
                        readOnly
                    />
                </label>
                <label className='edit-label-fix'>
                {t("edit.dateAndTimeOfTicketIssuance")}
                    <input
                        type="text"
                        value={ticket.create_time}
                        readOnly
                    />
                </label>
                <form>
                    <label className='edit-label'>
                    {t("edit.firstName")}
                        <input
                            type="text"
                            value={user.name}
                            onChange={(e) => setUser({ ...user, name: e.target.value })}
                        />
                    </label>
                    <label className='edit-label'>
                    {t("edit.lastName")}
                        <input
                            type="text"
                            value={user.surname}
                            onChange={(e) => setUser({ ...user, surname: e.target.value })}
                        />
                    </label>
                    <label className='edit-label'>
                    {t("edit.phoneNumber")}
                        <input
                            type="text"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </label>
                    <label className='edit-label'>
                    {t("edit.numberOfDaysTheTicketIsValid")}
                        <input
                            type="text"
                            value={ticket.day_no}
                            onChange={(e) => setTicket({ ...ticket, day_no: e.target.value })}
                        />
                    </label>
                    <label className='edit-label'>
                    {t("edit.numberOfPasses")}
                        <input
                            type="text"
                            value={ticket.entry_no}
                            onChange={(e) => setTicket({ ...ticket, entry_no: e.target.value })}
                        />
                    </label>
                    <label className='edit-label'>
                    {t("edit.numberOfDailyPasses")}
                        <input
                            type="text"
                            value={ticket.daily_no}
                            onChange={(e) => setTicket({ ...ticket, daily_no: e.target.value })}
                        />
                    </label>
                    <label className='edit-label'>
                    {t("edit.entryFrom")}
                        <input
                            type="time"
                            id="hFrom"
                            value={ticket.h_from}
                            onChange={(e) => setTicket({ ...ticket, h_from: e.target.value })}
                        />
                    </label>
                    <label className='edit-label'>
                    {t("edit.entryUntil")}
                        <input
                            type="time"
                            id="hTo"
                            value={ticket.h_to}
                            onChange={(e) => setTicket({ ...ticket, h_to: e.target.value })}
                        />
                    </label>
                    {readers.map((reader, index) => (
                        <div key={index} className='checkbox-container'>
                            <input
                                type="checkbox"
                                checked={ticket.readers.includes(Number(reader.id))}
                                onChange={(e) => handleCheckboxChange(reader.id, e.target.checked)}
                            />
                            <label>{reader.name}</label>
                        </div>
                    ))}
                    <div className='button-container'>
                        <button type="button" className='reader-button' onClick={handleSave}>{t("edit.save")}</button>
                        <button type="button" className='reader-button cancel-button' onClick={() => navigate('/')}>{t("edit.cancel")}</button>
                    </div>
                </form>
            </div>
            {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
            {succ && <Success message={succ} onClose={() => setSucc('')} />}
        </div>*/
    );
};

export default EditTicketByPlate;
